// extracted by mini-css-extract-plugin
module.exports = {"labels":"da51a739f7--labels--w3ZgM","label-item":"da51a739f7--label-item--DegjK","label":"da51a739f7--label--VulBy"};